import { PaymentComponent } from './../payment/components/payment.component';
import { CheckoutModule } from './../checkout/checkout.module';
import { PaymentModule } from './../payment/payment.module';
import { RouterModule } from '@angular/router';
import { PaymentFlowComponent } from './payment-flow.component';
import { AppLoginModule } from './../app-login/app-login.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { DynamicComponent } from './dynamic-component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    AppLoginModule,
    RouterModule,
    CheckoutModule,
    PaymentModule
  ],
  declarations: [
    PaymentFlowComponent, 
    // DynamicComponent
   ]

})
export class PaymentFlowModule { }



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/payment-flow/payment-flow.module.ts